// extracted by mini-css-extract-plugin
export default {"MenuDrawer":"Drawer_MenuDrawer__ShRSt","AccordionMenu":"Drawer_AccordionMenu__q9JgN","parent":"Drawer_parent__G2gr9","icon":"Drawer_icon__R2mBo","child":"Drawer_child__8dfek"};